__turbopack_context__.v({
  "colors": "vi7NAW_colors",
  "deviceImage": "vi7NAW_deviceImage",
  "root": "vi7NAW_root",
  "stickyContainer": "vi7NAW_stickyContainer",
  "text": "vi7NAW_text",
});
